"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _formik = require("formik");

var _Theme = _interopRequireDefault(require("../Theme"));

var _constant = require("../constant");

var _GuestPersonalInfo = require("../GuestPersonalInfo");

var _constant2 = require("./constant");

var _GuestSecurityInfo = _interopRequireDefault(require("./GuestSecurityInfo.proptypes"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "GuestSecurityInfo__StyledContainer",
  componentId: "sc-eum8cs-0"
})([""]);

var GuestSecurityInfo = function GuestSecurityInfo(_ref) {
  var accessible = _ref.accessible,
      theme = _ref.theme,
      customProperties = _ref.customProperties,
      initialValues = _ref.initialValues,
      onSubmit = _ref.onSubmit,
      formRef = _ref.formRef,
      translation = _ref.translation,
      handleField = _ref.handleField;

  var innerWidth = function innerWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : 300;
  };

  var _React$useState = _react.default.useState(innerWidth()),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      windowWidth = _React$useState2[0],
      setWindowWidth = _React$useState2[1];

  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', function () {
        return setWindowWidth(innerWidth());
      });
    }

    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', function () {
          return setWindowWidth(innerWidth());
        });
      }
    };
  }, []);

  var isMobile = windowWidth <= parseInt(_constant.BREAKPOINTS.MOBILE.replace('px', ''), 10);

  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATION), translation);

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledContainer, (0, _extends2.default)({}, customProperties, {
    tabIndex: !accessible ? '-1' : '0'
  }), /*#__PURE__*/_react.default.createElement(_formik.Formik, (0, _extends2.default)({
    innerRef: formRef,
    initialValues: initialValues,
    onSubmit: onSubmit,
    enableReinitialize: true
  }, customProperties), function (props) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      _react.default.createElement("form", {
        onSubmit: props.handleSubmit,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter') {
            props.handleSubmit();
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.Container, null, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        width: isMobile ? 100 : 50
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: _GuestPersonalInfo.renderField,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.redressNumber || _constant2.FIELDS.redressNumber.label,
        name: _constant2.FIELDS.redressNumber.name,
        theme: theme,
        handleField: handleField,
        value: props.values[_constant2.FIELDS.redressNumber.name],
        validate: function validate(val) {
          return (0, _GuestPersonalInfo.validators)(val, language.redressNumber || _constant2.FIELDS.redressNumber.label, language, [_GuestPersonalInfo.validate.alphanumeric, _GuestPersonalInfo.validate.maxLen]);
        }
      })), /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        width: isMobile ? 100 : 50
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: _GuestPersonalInfo.renderField,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.knownTravelerNumber || _constant2.FIELDS.knownTravelerNumber.label,
        name: _constant2.FIELDS.knownTravelerNumber.name,
        theme: theme,
        handleField: handleField,
        value: props.values[_constant2.FIELDS.knownTravelerNumber.name],
        validate: function validate(val) {
          return (0, _GuestPersonalInfo.validators)(val, language.knownTravelerNumber || _constant2.FIELDS.knownTravelerNumber.label, language, [_GuestPersonalInfo.validate.alphanumeric, _GuestPersonalInfo.validate.maxLen]);
        }
      }))))
    );
  })));
};

GuestSecurityInfo.propTypes = _GuestSecurityInfo.default.PropTypes;
GuestSecurityInfo.defaultProps = _GuestSecurityInfo.default.DefaultProps;
var _default = GuestSecurityInfo;
exports.default = _default;